import { ThemeColors } from '../../../'

export interface PrimaryButtonColors {
  Background: {
    Default: ThemeColors
    Hover: ThemeColors
  }
  FontColor: {
    Default: ThemeColors
    Active: ThemeColors
  }
}

export const primaryButtonColors: PrimaryButtonColors = {
  Background: {
    Default: {
      default: 'brand.solid',
    },
    Hover: {
      default: 'brand.emphasized',
    },
  },
  FontColor: {
    Default: {
      default: 'brand.contrast',
    },
    Active: {
      default: 'brand.contrast',
    },
  },
}
